import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.link";
import r from "react";
import m from "clsx";
import { ArrowRight as a } from "@hagerty/icons";

var p = function p(_ref) {
  var e = _ref.link,
      _ref$isElevated = _ref.isElevated,
      n = _ref$isElevated === void 0 ? !1 : _ref$isElevated,
      i = _ref.itemNumber;
  return r.createElement("li", {
    className: n ? "hg-primarynav__submenu-list-item--elevated" : "hg-primarynav__submenu-list-item",
    style: {
      "--primarynav-flyout-item-number": i.toString()
    }
  }, r.createElement("a", {
    href: e.url,
    className: m("hg-primarynav__submenu-link", {
      "hg-primarynav__submenu-link--base": !n
    })
  }, e.label, n && r.createElement("span", {
    className: "hg-primarynav__desktop-link-chevron"
  }, r.createElement(a, null))));
};

export { p as FlyoutLink };